// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EGZBk","title":"styles_title__v97ZI","description":"styles_description__WM4is","center":"styles_center__o+ba7"};